import { Link } from "react-router-dom";
import { Instagram, Mail, MessageCircle } from "lucide-react";

const LOGO = "https://customer-assets-m6fa6gv7.emergentagent.net/job_0dbeb9ed-131c-4cd1-83ca-d7c4e02f284b/artifacts/rg17olpw_WhatsApp%20Image%202026-10-01%20at%2011.40.01.jpeg";

export default function Footer() {
  return (
    <footer className="border-t border-white/10 bg-[#050505] pt-20 pb-10 mt-24">
      <div className="mx-auto max-w-7xl px-5 lg:px-8 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <img src={LOGO} alt="ActiveMode" className="h-16 w-16 object-contain" />
          <h2 className="font-display text-5xl lg:text-6xl text-white tracking-tighter mt-6">ACTIVEMODE</h2>
          <p className="text-zinc-400 mt-4 max-w-sm">Vestuário premium para quem vive em movimento. Qualidade, estilo e atitude em cada peça.</p>
        </div>

        <div className="md:col-span-3">
          <div className="overline-label mb-5">Loja</div>
          <ul className="space-y-3 text-sm">
            <li><Link to="/" className="text-zinc-300 hover:text-white">Novidades</Link></li>
            <li><Link to="/categoria/promocoes" className="text-zinc-300 hover:text-white">Promoções</Link></li>
            <li><Link to="/categoria/masculino" className="text-zinc-300 hover:text-white">Masculino</Link></li>
            <li><Link to="/categoria/feminino" className="text-zinc-300 hover:text-white">Feminino</Link></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="overline-label mb-5">Contato</div>
          <ul className="space-y-3 text-sm text-zinc-300">
            <li className="flex items-center gap-3"><MessageCircle size={16} /> WhatsApp disponível no botão lateral</li>
            <li className="flex items-center gap-3"><Mail size={16} /> contato@activemode.com.br</li>
            <li className="flex items-center gap-3"><Instagram size={16} /> @activemode</li>
          </ul>
        </div>
      </div>
      <div className="mx-auto max-w-7xl px-5 lg:px-8 mt-14 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
        <p className="text-xs text-zinc-500">© {new Date().getFullYear()} ActiveMode — Todos os direitos reservados.</p>
        <p className="text-xs text-zinc-500">Pix · Cartão · Entrega para todo o Brasil</p>
      </div>
    </footer>
  );
}
